import { getDoc, doc } from "firebase/firestore"
import { useState } from "react"
import { formatCurrency } from "../booking-configurator/formatters"
import Input from "../reusable-components/input"
import Button from "../reusable-components/button"

const PromoCodeForm = ({
  firestore,
  promoCode,
  setPromoCode,
  orderCurrency,
  promoCodeDiscount,
}) => {
  const [code, setCode] = useState("")
  const [appliedPromoCode, setAppliedPromoCode] = useState("")
  const [invalidPromocode, setInvalidPromocode] = useState(false)

  const applyPromoCode = async (e) => {
    e.preventDefault()
    const sanitizedCode = code.toUpperCase()
    const snapshot = await getDoc(doc(firestore, "coupons", sanitizedCode))

    if (snapshot.exists()) {
      setInvalidPromocode(false)
      setPromoCode(snapshot.data())
      setAppliedPromoCode(sanitizedCode)
      setCode("")
    } else {
      setInvalidPromocode(true)
      setPromoCode(undefined)
    }
  }

  return (
    <div className="flex flex-col gap-2">
      {promoCode && (
        <div className="flex justify-between">
          <p>
            {appliedPromoCode} -{" "}
            <span className="italic">{promoCode.description}</span>
          </p>
          <p>{formatCurrency(promoCodeDiscount, orderCurrency)}</p>
        </div>
      )}
      <div className="flex flex-col gap-2">
        <div className="flex gap-4">
          <div className="relative">
            <Input
              name="code"
              type="string"
              className="w-full"
              placeholder="Promo Code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
          </div>
          <div className="flex flex-col justify-center gap-2 w-48">
            <Button disabled={!code} title="Apply" onClick={applyPromoCode} />
          </div>
        </div>
        <div>
          {invalidPromocode && (
            <p className="text-red-400">Invalid promo code</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default PromoCodeForm
